import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-serif tracking-wider transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-1 focus:ring-[#D22B2B] relative overflow-hidden group';
  const variants = {
    primary: 'bg-[#D22B2B] text-white border border-[#D22B2B] shadow-[0_0_15px_rgba(210,43,43,0.3)] hover:shadow-[0_0_25px_rgba(210,43,43,0.5)] hover:bg-[#b01e1e]',
    secondary: 'bg-[#1f1f1f] text-gray-200 border border-[#333] hover:bg-[#2a2a2a] hover:border-[#555] hover:text-white',
    outline: 'bg-transparent text-gray-300 border border-[#444] hover:border-[#D22B2B] hover:text-[#D22B2B] hover:shadow-[0_0_10px_rgba(210,43,43,0.1)]',
    ghost: 'bg-transparent text-gray-400 hover:text-[#D22B2B] hover:bg-[#1f1f1f]'
  };
  const sizes = {
    sm: 'h-8 px-4 text-xs uppercase tracking-widest',
    md: 'h-11 px-6 text-sm uppercase tracking-widest',
    lg: 'h-14 px-8 text-base uppercase tracking-widest'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-169">
      {/* Shine effect on hover */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent z-10" data-id="element-170" />

      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-171" />}
      <span className="relative z-20 flex items-center" data-id="element-172">{children}</span>
    </button>;
}